import { render } from "./ConfigBudgetProteins.vue?vue&type=template&id=63982d89&scoped=true"
import script from "./ConfigBudgetProteins.vue?vue&type=script&lang=js"
export * from "./ConfigBudgetProteins.vue?vue&type=script&lang=js"

import "./ConfigBudgetProteins.vue?vue&type=style&index=0&id=63982d89&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63982d89"]])

export default __exports__